import { Link } from "@inertiajs/react";

type Props = {
  price: number;
  upgradeUrl: string;
};

export default function GuestJourneysUpgradeBanner({ price, upgradeUrl }: Props) {
  return (
    <div className="flex flex-col justify-between gap-4 rounded-lg border border-primary/20 bg-primary/5 px-5 py-4 sm:flex-row sm:items-center">
      <div>
        <h3 className="font-semibold text-gray-900">Audit journeys after they log in</h3>
        <p className="mt-1 max-w-2xl text-sm leading-relaxed text-gray-600">
          This pass covered public pages. Most SaaS friction shows up after signup — empty states, first create,
          billing. {`Pro is $${price}/mo for 1 domain.`}
        </p>
      </div>
      <Link href={upgradeUrl} className="btn btn-primary w-fit shrink-0">
        Upgrade
      </Link>
    </div>
  );
}
